import type { paths } from './codegen/management.types'
import { HOST } from '@/globals/typescript/utils/host'
import { i18n } from '@/locales'
import { useUserStore } from '@/stores/userStore'

import { getCurrentUserBearer } from './getCurrentUserBearer'
import { reportApiTransportFailure } from '@/globals/typescript/utils/reportError'
import { createLabApiClient } from '@team-milva/lab-utils'

export const managementApi = createLabApiClient<paths>({
  baseUrl: () => `${HOST.functions}/management/v1`,
  defaultHeaders: () => {
    return {
      'Accept-Language': i18n.global.locale.value,
      // Only set while an admin is impersonating a real employee (Mode
      // User) — empty for Mode Self/None. See userStore's
      // `impersonationApiHeaders` getter.
      ...useUserStore().impersonationApiHeaders,
    }
  },
  getBearerToken: getCurrentUserBearer,
  onTransportFailure: (info) => reportApiTransportFailure('management', info),
})

